import * as React from 'react';
import ReactTable, {ExpandedChangeFunction, TableProps} from 'react-table';
import {injectThProps} from "HelperFunctions/Lists";
import {Waypoint} from "react-waypoint";
import {PureComponent, RefObject} from "react";
import {Types} from '../../Models/InfinityTableModel';
import * as InfinityTableModule from 'Modules/InfinityTableModule';
import {connect} from "react-redux";
import {RootState} from "Redux/Reducers/_RootReducer";

type tableProps = {
    addClass?: string;
    data: any;
    dataLength?: number;
    columns: any;
    onFetchData?: Function;
    filterable?: boolean;
    resizable?: boolean;
    defaultFiltered?: TableProps['defaultFiltered']

    getTheadThProps?: any;
    waypointRef?: RefObject<any>;

    loadingText?: string;
    pageText?: string;
    nextText?: string;
    previousText?: string;
    rowsText?: string;
    noDataText?: string;
    getTrProps?: Function;

    defaultPageSize?: number;
    pageSize?: number;

    onExpandedChange?: ExpandedChangeFunction;
    expanded?: any;

    SubComponent?: any;
    manual?: boolean;
    afterInit?: boolean;
    allowBackWaypoint?: boolean;
    activeId?: number;

    /** Przydatna metoda gdy mamy w tabelce manual == true, pozwala na samodzielne filtrowanie. */
    onFilteredChange?: TableProps['onFilteredChange'];
}

export class InfinityScrollParams {
    private itemsFirstLoad: number;
    private itemsPerLoad: number = 0;
    private itemsPerPageLoad: number = 10;
    private currentPage: number = 0;
    private isLoading: boolean = false;
    private activeFilters: Array<{ id: string; value: any }> = null;
    private waypointRef = null;

    constructor(_itemsFirstLoad = 30, _waypointRef = null) {
        this.itemsFirstLoad = _itemsFirstLoad;
        this.waypointRef = _waypointRef;
    }

    public prepareLoadParams(state, scrollLoad) {
        const defaultFilter = [
            {id: 'first', value: 0},
            {id: 'max', value: this.itemsFirstLoad}
        ];

        if (!scrollLoad) {
            this.activeFilters = state !== null ? state.filtered || defaultFilter : defaultFilter;
            this.currentPage = 0;
            this.itemsPerLoad = this.itemsFirstLoad;
        } else {
            this.itemsPerLoad = this.itemsPerPageLoad;
            this.currentPage++;
        }

        this.isLoading = true;

        return {
            activeFilters: this.activeFilters,
            currentPage: this.currentPage,
            itemsPerLoad: this.itemsPerLoad,
            itemsFirstLoad: this.itemsFirstLoad
        };
    }

    public setWaypointRef(waypoint) {
        this.waypointRef = waypoint;
    }

    public getWaypointRef() {
        return this.waypointRef;
    }

    public setLoading(value) {
        this.isLoading = value;
    }

    public getIsLoading() {
        return this.isLoading;
    }

    public getItemsFirstLoad() {
        return this.itemsFirstLoad;
    }
};

export class InfinityReactTable extends React.PureComponent<tableProps, any> {

    constructor(props) {
        super(props);
        this.pageSize = Math.ceil(window.innerHeight / 28);
        this.windowResize = this.windowResize.bind(this);
        this.isResizing = false;
    }

    private pageSize;
    private isResizing;

    private windowResize() {
        if (!this.isResizing) {
            this.isResizing = true;
            setTimeout(() => {
                this.pageSize = Math.ceil(window.innerHeight / 28);
                this.props.onFetchData.call(this, null, false, this.pageSize);
                this.isResizing = false;
            }, 1500);
        }
    }

    // public shouldComponentUpdate(nextProps: Readonly<tableProps>, nextState: Readonly<any>, nextContext: any): boolean {
    //     console.log('---', nextState === this.state, nextState, this.state);
    //     console.log('+++', nextProps === this.props, nextProps, this.props);
    // }

    public componentDidMount() {
        window.addEventListener('resize', this.windowResize);
    }

    public componentWillUnmount() {
        window.removeEventListener('resize', this.windowResize);
    }

    public render() {
        const {
            addClass,
          data, dataLength = data.length,
          columns,
          onFetchData,
          filterable,
          resizable,
          waypointRef,
          loadingText,
          pageText,
          nextText,
          previousText,
          rowsText,
          noDataText,
          getTrProps,
          onExpandedChange,
          pageSize,
          expanded,
          SubComponent,
          manual,
          allowBackWaypoint = false,
          onFilteredChange,
          defaultFiltered = []
        } = this.props;

        return (
            <div data-testid={'vehicles-table'}>
                {allowBackWaypoint &&
                <Waypoint onEnter={onFetchData.bind(this, null, false)} scrollableAncestor={waypointRef.current}/>}
                <ReactTable
                    className={addClass}
                    data={data}
                    columns={columns}
                    onFetchData={(state, instance) => onFetchData.call(this, state, false, this.pageSize)}
                    filterable={filterable}
                    resizable={resizable}
                    defaultFiltered={defaultFiltered}

                    getTheadThProps={injectThProps}
                    loadingText={loadingText}
                    pageText={pageText}
                    nextText={nextText}
                    previousText={previousText}
                    rowsText={rowsText}
                    noDataText={noDataText}

                    getTrProps={(state, rowInfo, column) => getTrProps.call(this, state, rowInfo, column)}

                    defaultPageSize={this.pageSize || 30}
                    pageSize={pageSize || 0}

                    onExpandedChange={onExpandedChange}
                    expanded={expanded}

                    SubComponent={SubComponent}
                    manual={typeof manual !== 'undefined' ? manual : true}
                    onFilteredChange={onFilteredChange}
                />
                {dataLength > 0 && dataLength >= this.pageSize &&
                <Waypoint onEnter={onFetchData.bind(this, null, true, this.pageSize)} bottomOffset={'-2px'}/>}
            </div>
        );
    }

}


export type ConnectedProps = {
    infinityTableStore: Types.InfinityTableStore
};

export type DispatchedProps = {
    setInfinityTableCount: Function;
    setInfinityTableLoading: Function;
}

class FooterComponent extends PureComponent<DispatchedProps & ConnectedProps, any> {

    public render() {
        return (
            <div className="table__footer">
                <div>
                    wyników: {this.props.infinityTableStore.count} {this.props.infinityTableStore.totalCount !== null &&
                <span>z {this.props.infinityTableStore.totalCount}</span>}

                </div>
                {this.props.infinityTableStore.isLoading && <div className="table__footer-loader"/>}
            </div>
        )
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        infinityTableStore: state.infinityTableStore
    };
}

function mapDispatchToProps(dispatch: any): DispatchedProps {
    return {
        setInfinityTableCount: (count: number) => dispatch(InfinityTableModule.Actions.setInfinityTableCount(count)),
        setInfinityTableLoading: (value: boolean) => dispatch(InfinityTableModule.Actions.setInfinityTableLoading(value)),
    };
}

export const Footer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FooterComponent) as React.ComponentClass<any>;



// WEBPACK FOOTER //
// ./src/components/common/InfinityReactTable.tsx